import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";
import { Trash2 } from "lucide-react";

const AdminTags = () => {
  const [tags, setTags] = useState([]);
  const [name, setName] = useState("");

  const load = async () => {
    const res = await api.get("/tags");
    setTags(res.data);
  };

  const create = async (e) => {
    e.preventDefault();

    try {
      await api.post("/tags", { name });
      toast.success("Tag created");
      setName("");
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete tag?")) return;

    try {
      await api.delete(`/tags/${id}`);
      toast.success("Tag deleted");
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <section>
      <h1 className="text-3xl font-black text-[#0b6b1d] mb-6">Tags</h1>

      <form onSubmit={create} className="bg-white rounded-3xl p-6 border mb-6 flex gap-3">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          placeholder="Tag name"
          className="flex-1 border rounded-2xl px-4 py-3"
        />

        <button className="px-6 rounded-2xl bg-[#0b6b1d] text-white font-bold">
          Add
        </button>
      </form>

      <div className="bg-white rounded-3xl border overflow-hidden">
        {tags.map((tag) => (
          <div key={tag.id} className="p-4 border-b flex justify-between">
            <div>
              <p className="font-bold">{tag.name}</p>
              <p className="text-xs text-slate-500">{tag.slug}</p>
            </div>

            <button onClick={() => remove(tag.id)} className="text-red-600">
              <Trash2 size={18} />
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AdminTags;